import { Modal } from '../../../../components/common/Modal';
import { useLanguage } from '../../../../features/language/useLanguage';

interface HighShrinkageWarningModalProps {
  isOpen: boolean;
  items: { name: string; shrinkage: number }[];
  onClose: () => void;
  onProceed: () => void;
}

/** Warns when received weight is dramatically lower than ordered (>30% shrinkage). */
export function HighShrinkageWarningModal({ isOpen, items, onClose, onProceed }: HighShrinkageWarningModalProps) {
  const { t } = useLanguage();
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t('purchaseOrder.form.modals.highShrinkageTitle')} maxWidth="md">
      <div className="space-y-4">
        <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-md">
          <p className="text-yellow-800 font-medium">{t('purchaseOrder.form.modals.highShrinkageWarning')}</p>
          <ul className="mt-2 list-disc list-inside text-sm text-yellow-700">
            {items.map((item, index) => (
              <li key={index}>
                {t('purchaseOrder.form.modals.highShrinkageItem', {
                  name: item.name,
                  shrinkage: item.shrinkage.toFixed(1),
                })}
              </li>
            ))}
          </ul>
          <p className="mt-3 text-sm text-yellow-800">{t('purchaseOrder.form.modals.highShrinkageConfirm')}</p>
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 font-medium"
          >
            {t('auth.common.cancel')}
          </button>
          <button
            onClick={onProceed}
            className="px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 font-medium"
          >
            {t('purchaseOrder.form.modals.proceed')}
          </button>
        </div>
      </div>
    </Modal>
  );
}
